export default __webpack_public_path__ + "static/media/sellingTerminalPoint.76758801.svg";